module.exports = __webpack_public_path__ + "1c4f9ed06498ef86cb334173fb4cfb.png";